import { Resource } from 'model/Resource';
import { StaticResourceModel } from 'api/dto/StaticResource.dto';

export const STORE_NAME = 'staticResource';

export namespace StaticResourceState {
  export type Domain = {
    listResource: Resource<StaticResourceModel[]>;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource<StaticResourceModel[]>(),
  };
}
